export default {
  iconCol: {
    width: 80,
  },
  nameCol: {
  },
  relativeToCol: {
    width: 250,
  },
  qualityControlCol: {
    width: 150,
  },
  actionCol: {
    width: 150,
  },
  icon: {
    width: 30,
    height: 30,
  },
};



// WEBPACK FOOTER //
// ./src/components/StagesTable/styles.js